const isXSM = (options) => {
    const { index, length, limit, page } = options;
    if (length <= limit) {
        return false;
    }
    if (page < 2) {
        return index === 4;
    }
    if (page >= length - 2) {
        return index === 0;
    }
    return false;
};
const isSmall = (options) => {
    const { index, length, limit, page } = options;
    if (length <= limit) {
        return false;
    }
    if (page < 2) {
        return index === 3;
    }
    if (page >= length - 2) {
        return index === 1;
    }
    return index === 0 || index === 4;
};
const isActive = (options) => {
    const { index, length, limit, page } = options;
    if (length <= limit || page < 3) {
        return page === index;
    }
    if (page === length - 1) {
        return index === 4;
    }
    if (page === length - 2) {
        return index === 3;
    }
    return index === 2;
};
export { isActive, isSmall, isXSM, };
//# sourceMappingURL=bullet-trail-utils.js.map